export function resolveEventShareOrigin(providedOrigin) {
  if (providedOrigin) {
    return String(providedOrigin).replace(/\/$/, "");
  }

  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin.replace(/\/$/, "");
  }

  return String(process.env.REACT_APP_BASE_URL || "")
    .replace(/\/event\/?$/, "")
    .replace(/\/$/, "");
}

/**
 * Public event URL for copy, social share, and embed (no login required).
 */
export function buildPublicEventShareUrl(eventId, options = {}) {
  const { referralId, origin } = options;

  if (!eventId) {
    return "";
  }

  const base = resolveEventShareOrigin(origin);
  const params = new URLSearchParams({ eventId: String(eventId) });

  if (referralId) {
    params.set("referralId", String(referralId));
  }

  return `${base}/event/pub-access/details/${eventId}?${params.toString()}`;
}
